<div class="week-grid" [class.selecting]="isSelecting" [class.readonly]="!editMode"
  [style.--day-count]="weekdays.length">
  <div class="day-header"></div>
  <div *ngFor="let day of weekdays" [attr.data-day]="day" class="day-header">
    <span>{{ dayLabel(day) }}</span>
    <button *ngIf="editMode" (click)="invertDay(day)" [attr.aria-label]="'WEEKLY_SELECTOR.INVERT_DAY' | translate"
      [title]="'WEEKLY_SELECTOR.INVERT_DAY' | translate"
      class="invert-day" type="button">
      <span class="material-symbols-outlined">flip</span>
    </button>
  </div>

  <ng-container *ngFor="let slot of slots; trackBy: trackByIndex">
    <div class="time-label">{{ hourLabel(slot) }}</div>
    <div *ngFor="let day of weekdays" [attr.data-day]="day" [attr.data-slot]="slot" class="slot"
      [class.hour-start]="isHourStart(slot)"
      [class.selected]="isSlotSelected(slot, day)"
      [class.run-start]="isSlotSelected(slot, day) && !isSlotSelected(slot - 1, day)"
      [class.run-end]="isSlotSelected(slot, day) && !isSlotSelected(slot + 1, day)"
      (pointerdown)="startSelect($event, slot, day)" (pointerenter)="onSlotDrag(slot, day)">
      <span *ngIf="runLabel(slot, day) as label" class="run-label">{{ label }}</span>
    </div>
  </ng-container>
</div>
